import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProcessStepModel } from '../../process.model';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../app.service';
import { selectStepById } from '../../selectors/process.selectors';

@Component({
  selector: 'mj-process-qualified',
  templateUrl: './process-qualified.component.html',
  styleUrls: ['./process-qualified.component.scss'],
})
export class ProcessQualifiedComponent implements OnInit {
  @Input() stepId: number;
  @Output() processChanged = new EventEmitter();

  step: ProcessStepModel;
  isStepActive: boolean;

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.store.pipe(select(selectStepById(1))).subscribe(data => {
      this.step = data;
    });
  }
}
